var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBcbearingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "98px",
    height: "31px",
    viewBox: "0 0 98 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.215686%,20%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 20.378906 7.121094 C 19.636719 5.25 18.328125 3.964844 16.449219 3.265625 C 20.101562 2.367188 23.425781 3.035156 26.425781 5.273438 C 28.394531 6.976562 29.625 9.117188 30.113281 11.683594 C 28.675781 11.683594 27.234375 11.683594 25.796875 11.683594 C 24.949219 9.027344 23.144531 7.503906 20.378906 7.121094 Z M 20.378906 7.121094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.941176%,12.941176%,12.156863%)",
      fillOpacity: 1
    },
    d: "M 16.449219 3.265625 C 18.328125 3.964844 19.636719 5.25 20.378906 7.121094 C 20.996094 8.988281 20.75 10.71875 19.632812 12.3125 C 19.488281 12.457031 19.34375 12.601562 19.199219 12.746094 C 21.074219 13.96875 22.015625 15.714844 22.027344 17.976562 C 21.988281 18.808594 21.859375 19.621094 21.632812 20.417969 C 20.757812 22.652344 19.164062 24.066406 16.84375 24.667969 C 16.53125 24.707031 16.214844 24.746094 15.902344 24.785156 C 11.53125 24.824219 7.160156 24.835938 2.789062 24.824219 C 2.789062 17.558594 2.789062 10.292969 2.789062 3.027344 C 7 3.015625 11.214844 3.027344 15.429688 3.070312 C 15.773438 3.121094 16.113281 3.1875 16.449219 3.265625 Z M 13.230469 11.210938 C 13.78125 10.082031 14.539062 9.113281 15.507812 8.300781 C 15.320312 7.96875 15.03125 7.769531 14.644531 7.710938 C 13.203125 7.644531 11.765625 7.660156 10.324219 7.75 C 9.589844 8.804688 9.066406 9.957031 8.753906 11.210938 C 8.179688 11.210938 7.605469 11.210938 7.027344 11.210938 C 7.027344 9.820312 7.027344 8.433594 7.027344 7.042969 C 9.542969 7.027344 12.054688 7.042969 14.566406 7.082031 C 15.894531 7.367188 16.457031 8.195312 16.253906 9.558594 C 16.074219 10.5 15.511719 11.039062 14.566406 11.171875 C 14.121094 11.210938 13.675781 11.226562 13.230469 11.210938 Z M 8.519531 15.382812 C 8.71875 17.042969 9.28125 18.566406 10.207031 19.945312 C 11.8125 20.035156 13.421875 20.050781 15.039062 19.984375 C 15.378906 19.964844 15.691406 19.875 15.980469 19.710938 C 14.300781 18.738281 13.253906 17.292969 12.839844 15.382812 C 13.808594 15.367188 14.777344 15.382812 15.746094 15.421875 C 17.003906 15.816406 17.65625 16.679688 17.707031 18.019531 C 17.652344 19.3125 17.023438 20.179688 15.824219 20.613281 C 12.890625 20.652344 9.960938 20.667969 7.027344 20.652344 C 7.027344 18.894531 7.027344 17.140625 7.027344 15.382812 C 7.523438 15.382812 8.023438 15.382812 8.519531 15.382812 Z M 8.519531 15.382812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.215686%,20%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 13.230469 11.210938 C 12.6875 12.296875 12.492188 13.449219 12.644531 14.675781 C 12.648438 14.9375 12.710938 15.171875 12.839844 15.382812 C 13.253906 17.292969 14.300781 18.738281 15.980469 19.710938 C 15.691406 19.875 15.378906 19.964844 15.039062 19.984375 C 13.421875 20.050781 11.8125 20.035156 10.207031 19.945312 C 9.28125 18.566406 8.71875 17.042969 8.519531 15.382812 C 8.371094 13.976562 8.449219 12.589844 8.753906 11.210938 C 9.066406 9.957031 9.589844 8.804688 10.324219 7.75 C 11.765625 7.660156 13.203125 7.644531 14.644531 7.710938 C 15.03125 7.769531 15.320312 7.96875 15.507812 8.300781 C 14.539062 9.113281 13.78125 10.082031 13.230469 11.210938 Z M 13.230469 11.210938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 73.066406 8.222656 C 74.246094 8.183594 74.679688 8.734375 74.363281 9.875 C 73.671875 10.625 73.015625 10.597656 72.402344 9.796875 C 72.175781 9.070312 72.398438 8.546875 73.066406 8.222656 Z M 73.066406 8.222656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 33.175781 8.457031 C 35.453125 8.445312 37.730469 8.457031 40.007812 8.496094 C 41.648438 8.84375 42.511719 9.851562 42.601562 11.527344 C 42.59375 12.515625 42.175781 13.261719 41.34375 13.769531 C 43.019531 14.636719 43.582031 15.988281 43.03125 17.820312 C 42.480469 19.0625 41.523438 19.757812 40.164062 19.90625 C 37.835938 19.945312 35.507812 19.957031 33.175781 19.945312 C 33.175781 16.117188 33.175781 12.289062 33.175781 8.457031 Z M 35.375 10.503906 C 36.683594 10.492188 37.992188 10.503906 39.300781 10.542969 C 40.375 10.878906 40.648438 11.546875 40.125 12.550781 C 39.902344 12.785156 39.625 12.929688 39.300781 12.980469 C 37.992188 13.023438 36.683594 13.035156 35.375 13.023438 C 35.375 12.183594 35.375 11.34375 35.375 10.503906 Z M 35.375 15.066406 C 36.84375 15.054688 38.308594 15.066406 39.773438 15.105469 C 40.949219 15.453125 41.273438 16.175781 40.753906 17.269531 C 40.535156 17.53125 40.261719 17.699219 39.929688 17.78125 C 38.414062 17.820312 36.894531 17.835938 35.375 17.820312 C 35.375 16.902344 35.375 15.984375 35.375 15.066406 Z M 35.375 15.066406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 48.488281 10.820312 C 51.980469 10.882812 53.734375 12.664062 53.75 16.167969 C 51.34375 16.167969 48.933594 16.167969 46.527344 16.167969 C 46.824219 17.582031 47.699219 18.339844 49.15625 18.449219 C 49.769531 18.394531 50.332031 18.199219 50.84375 17.859375 C 51.121094 17.585938 51.394531 17.308594 51.667969 17.035156 C 52.226562 17.332031 52.765625 17.660156 53.28125 18.019531 C 51.835938 19.828125 49.980469 20.484375 47.703125 19.984375 C 45.21875 19.09375 44.109375 17.324219 44.367188 14.675781 C 44.898438 12.476562 46.273438 11.191406 48.488281 10.820312 Z M 48.648438 12.550781 C 50.027344 12.546875 50.96875 13.1875 51.472656 14.476562 C 49.824219 14.542969 48.175781 14.53125 46.527344 14.4375 C 46.867188 13.390625 47.574219 12.757812 48.648438 12.550781 Z M 48.648438 12.550781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 59.011719 10.820312 C 60.328125 10.664062 61.441406 11.058594 62.347656 12 C 62.386719 11.683594 62.402344 11.371094 62.386719 11.054688 C 63.042969 11.054688 63.699219 11.054688 64.351562 11.054688 C 64.351562 14.019531 64.351562 16.980469 64.351562 19.945312 C 63.699219 19.945312 63.042969 19.945312 62.386719 19.945312 C 62.402344 19.628906 62.386719 19.316406 62.347656 19 C 61.25 20.042969 59.953125 20.394531 58.460938 20.0625 C 56.476562 19.515625 55.3125 18.214844 54.96875 16.167969 C 54.859375 13.265625 56.207031 11.480469 59.011719 10.820312 Z M 59.167969 12.707031 C 61.363281 12.664062 62.449219 13.738281 62.429688 15.933594 C 62.007812 17.585938 60.949219 18.359375 59.246094 18.253906 C 57.863281 17.863281 57.101562 16.945312 56.96875 15.5 C 57.109375 14.089844 57.84375 13.160156 59.167969 12.707031 Z M 59.167969 12.707031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 69.847656 10.820312 C 70.136719 10.804688 70.425781 10.820312 70.710938 10.859375 C 70.949219 10.886719 71.160156 10.976562 71.339844 11.132812 C 71.113281 11.753906 70.878906 12.371094 70.632812 12.980469 C 69.785156 12.59375 69.144531 12.816406 68.710938 13.652344 C 68.671875 15.75 68.65625 17.847656 68.671875 19.945312 C 68.015625 19.945312 67.363281 19.945312 66.707031 19.945312 C 66.707031 16.980469 66.707031 14.019531 66.707031 11.054688 C 67.308594 11.054688 67.910156 11.054688 68.511719 11.054688 C 68.5 11.34375 68.515625 11.632812 68.554688 11.921875 C 68.835938 11.363281 69.265625 10.996094 69.847656 10.820312 Z M 69.847656 10.820312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 80.84375 10.820312 C 83.128906 10.761719 84.449219 11.863281 84.808594 14.125 C 84.847656 16.0625 84.859375 18.003906 84.847656 19.945312 C 84.191406 19.945312 83.539062 19.945312 82.882812 19.945312 C 82.917969 18.027344 82.878906 16.113281 82.765625 14.203125 C 82.488281 13.242188 81.847656 12.769531 80.84375 12.785156 C 79.871094 12.792969 79.203125 13.238281 78.839844 14.125 C 78.726562 16.058594 78.6875 18 78.722656 19.945312 C 78.066406 19.945312 77.414062 19.945312 76.757812 19.945312 C 76.757812 16.980469 76.757812 14.019531 76.757812 11.054688 C 77.414062 11.054688 78.066406 11.054688 78.722656 11.054688 C 78.707031 11.371094 78.722656 11.683594 78.761719 12 C 79.316406 11.34375 80.011719 10.953125 80.84375 10.820312 Z M 80.84375 10.820312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 90.421875 10.820312 C 91.378906 10.730469 92.269531 10.925781 93.09375 11.410156 C 93.316406 11.578125 93.515625 11.777344 93.679688 12 C 93.71875 11.683594 93.734375 11.371094 93.71875 11.054688 C 94.347656 11.054688 94.976562 11.054688 95.605469 11.054688 C 95.617188 13.859375 95.605469 16.667969 95.566406 19.472656 C 95.277344 21.652344 94.058594 22.976562 91.914062 23.445312 C 90.398438 23.695312 89.039062 23.351562 87.832031 22.425781 C 87.59375 22.210938 87.382812 21.976562 87.203125 21.714844 C 87.738281 21.351562 88.261719 20.96875 88.773438 20.574219 C 90.277344 22.027344 91.78125 22.027344 93.289062 20.574219 C 93.667969 19.996094 93.800781 19.367188 93.679688 18.6875 C 92.753906 19.667969 91.613281 20.078125 90.265625 19.90625 C 88.335938 19.625 87.117188 18.535156 86.613281 16.640625 C 86.160156 14.570312 86.75 12.878906 88.378906 11.566406 C 89.027344 11.195312 89.707031 10.949219 90.421875 10.820312 Z M 90.65625 12.707031 C 92.234375 12.609375 93.242188 13.320312 93.679688 14.832031 C 93.875 16.445312 93.207031 17.507812 91.679688 18.019531 C 89.9375 18.1875 88.90625 17.414062 88.578125 15.695312 C 88.523438 14.164062 89.21875 13.167969 90.65625 12.707031 Z M 90.65625 12.707031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.964706,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,12.54902%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 72.441406 11.054688 C 73.09375 11.054688 73.75 11.054688 74.402344 11.054688 C 74.402344 14.019531 74.402344 16.980469 74.402344 19.945312 C 73.75 19.945312 73.09375 19.945312 72.441406 19.945312 C 72.441406 16.980469 72.441406 14.019531 72.441406 11.054688 Z M 72.441406 11.054688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.215686%,20%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 16.84375 24.667969 C 19.164062 24.066406 20.757812 22.652344 21.632812 20.417969 C 23.835938 19.65625 25.300781 18.160156 26.03125 15.933594 C 27.445312 15.855469 28.855469 15.828125 30.273438 15.855469 C 29.480469 19.835938 27.226562 22.628906 23.519531 24.234375 C 21.332031 25.007812 19.109375 25.152344 16.84375 24.667969 Z M 16.84375 24.667969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(74.509804%,1.568627%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 68.90625 22.933594 C 69.535156 22.933594 70.164062 22.933594 70.789062 22.933594 C 70.777344 23.539062 70.789062 24.140625 70.832031 24.746094 C 71.3125 24.15625 71.796875 23.566406 72.28125 22.976562 C 73.042969 22.910156 73.800781 22.921875 74.558594 23.015625 C 73.871094 23.753906 73.191406 24.5 72.519531 25.257812 C 73.320312 26.429688 74.132812 27.597656 74.953125 28.757812 C 74.167969 28.863281 73.382812 28.863281 72.597656 28.757812 C 72.140625 28.050781 71.679688 27.339844 71.222656 26.632812 C 71.09375 26.765625 70.960938 26.894531 70.832031 27.027344 C 70.789062 27.628906 70.777344 28.234375 70.789062 28.835938 C 70.164062 28.835938 69.535156 28.835938 68.90625 28.835938 C 68.90625 26.871094 68.90625 24.902344 68.90625 22.933594 Z M 68.90625 22.933594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.92549,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,9.803922%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 75.972656 23.015625 C 76.6875 22.929688 76.976562 23.230469 76.835938 23.917969 C 76.261719 24.453125 75.84375 24.347656 75.582031 23.605469 C 75.644531 23.355469 75.777344 23.160156 75.972656 23.015625 Z M 75.972656 23.015625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.92549,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,9.803922%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 77.464844 23.015625 C 78.105469 22.910156 78.40625 23.171875 78.367188 23.800781 C 77.949219 24.429688 77.53125 24.429688 77.113281 23.800781 C 77.082031 23.46875 77.199219 23.207031 77.464844 23.015625 Z M 77.464844 23.015625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,34.117647%,34.509804%)",
      fillOpacity: 1
    },
    d: "M 82.097656 23.015625 C 82.203125 23.066406 82.203125 23.066406 82.097656 23.015625 Z M 82.097656 23.015625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00784314,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.941176%,34.117647%,34.509804%)",
      fillOpacity: 1
    },
    d: "M 82.097656 23.09375 C 82.046875 23.144531 82.046875 23.144531 82.097656 23.09375 Z M 82.097656 23.09375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.92549,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.941176%,9.803922%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 75.03125 24.507812 C 75.503906 24.507812 75.972656 24.507812 76.445312 24.507812 C 76.429688 25.480469 76.445312 26.449219 76.484375 27.421875 C 76.824219 27.945312 77.164062 27.945312 77.503906 27.421875 C 77.542969 26.449219 77.558594 25.480469 77.542969 24.507812 C 78.015625 24.507812 78.488281 24.507812 78.957031 24.507812 C 78.992188 25.667969 78.953125 26.824219 78.839844 27.972656 C 78.445312 28.695312 77.828125 29.007812 76.996094 28.914062 C 76.160156 29.007812 75.542969 28.695312 75.148438 27.972656 C 75.035156 26.824219 74.996094 25.667969 75.03125 24.507812 Z M 75.03125 24.507812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.921569,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.941176%,9.803922%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 79.507812 24.902344 C 79.507812 24.851562 79.507812 24.796875 79.507812 24.746094 C 79.507812 24.667969 79.507812 24.585938 79.507812 24.507812 C 80.449219 24.496094 81.390625 24.507812 82.335938 24.546875 C 83.261719 24.996094 83.5625 25.71875 83.238281 26.710938 C 82.9375 27.195312 82.507812 27.472656 81.941406 27.539062 C 81.601562 27.578125 81.261719 27.589844 80.921875 27.578125 C 80.921875 27.996094 80.921875 28.417969 80.921875 28.835938 C 80.449219 28.835938 79.976562 28.835938 79.507812 28.835938 C 79.507812 27.523438 79.507812 26.214844 79.507812 24.902344 Z M 80.921875 25.6875 C 81.234375 25.675781 81.550781 25.6875 81.863281 25.726562 C 82.074219 25.9375 82.074219 26.148438 81.863281 26.359375 C 81.550781 26.398438 81.234375 26.410156 80.921875 26.398438 C 80.921875 26.160156 80.921875 25.925781 80.921875 25.6875 Z M 80.921875 25.6875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.913725,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.941176%,9.803922%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 84.769531 23.015625 C 84.847656 23.496094 84.871094 23.996094 84.847656 24.507812 C 85.578125 24.507812 86.3125 24.507812 87.046875 24.507812 C 87.046875 24.902344 87.046875 25.296875 87.046875 25.6875 C 86.390625 25.6875 85.738281 25.6875 85.082031 25.6875 C 85.082031 25.820312 85.082031 25.953125 85.082031 26.082031 C 85.65625 26.082031 86.234375 26.082031 86.808594 26.082031 C 86.808594 26.449219 86.808594 26.816406 86.808594 27.183594 C 86.234375 27.183594 85.65625 27.183594 85.082031 27.183594 C 85.082031 27.734375 85.082031 28.285156 85.082031 28.835938 C 84.613281 28.835938 84.140625 28.835938 83.667969 28.835938 C 83.667969 27.394531 83.667969 25.953125 83.667969 24.507812 C 84.035156 24.507812 84.402344 24.507812 84.769531 24.507812 C 84.769531 24.011719 84.769531 23.511719 84.769531 23.015625 Z M 84.769531 23.015625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.913725,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,9.803922%,7.843137%)",
      fillOpacity: 1
    },
    d: "M 87.359375 24.507812 C 88.589844 24.507812 89.820312 24.507812 91.050781 24.507812 C 91.050781 24.902344 91.050781 25.296875 91.050781 25.6875 C 90.292969 25.6875 89.53125 25.6875 88.773438 25.6875 C 88.773438 25.820312 88.773438 25.953125 88.773438 26.082031 C 89.453125 26.082031 90.132812 26.082031 90.816406 26.082031 C 90.816406 26.449219 90.816406 26.816406 90.816406 27.183594 C 90.132812 27.183594 89.453125 27.183594 88.773438 27.183594 C 88.773438 27.339844 88.773438 27.5 88.773438 27.65625 C 89.53125 27.65625 90.292969 27.65625 91.050781 27.65625 C 91.050781 28.050781 91.050781 28.441406 91.050781 28.835938 C 89.820312 28.835938 88.589844 28.835938 87.359375 28.835938 C 87.359375 27.394531 87.359375 25.953125 87.359375 24.507812 Z M 87.359375 24.507812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.917647,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,9.803922%,7.843137%)",
      fillOpacity: 1
    },
    d: "M 91.523438 24.507812 C 92.570312 24.496094 93.617188 24.507812 94.664062 24.546875 C 95.476562 24.921875 95.726562 25.539062 95.410156 26.398438 C 95.289062 26.566406 95.148438 26.710938 94.976562 26.828125 C 95.253906 27 95.421875 27.25 95.488281 27.578125 C 95.523438 27.996094 95.5625 28.417969 95.605469 28.835938 C 95.160156 28.847656 94.714844 28.835938 94.269531 28.796875 C 94.191406 28.363281 94.101562 27.929688 93.996094 27.5 C 93.9375 27.449219 93.871094 27.410156 93.800781 27.378906 C 93.511719 27.339844 93.222656 27.328125 92.933594 27.339844 C 92.933594 27.839844 92.933594 28.339844 92.933594 28.835938 C 92.464844 28.835938 91.992188 28.835938 91.523438 28.835938 C 91.523438 27.394531 91.523438 25.953125 91.523438 24.507812 Z M 92.933594 25.609375 C 93.25 25.597656 93.5625 25.609375 93.878906 25.648438 C 94.15625 25.820312 94.183594 26.03125 93.957031 26.277344 C 93.617188 26.320312 93.277344 26.332031 92.933594 26.320312 C 92.933594 26.082031 92.933594 25.847656 92.933594 25.609375 Z M 92.933594 25.609375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.12549,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 98,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.72549%,33.72549%,35.294118%)",
      fillOpacity: 1
    },
    d: "M 79.507812 24.746094 C 79.507812 24.796875 79.507812 24.851562 79.507812 24.902344 C 79.386719 24.992188 79.253906 25.03125 79.113281 25.019531 C 79.191406 24.851562 79.324219 24.757812 79.507812 24.746094 Z M 79.507812 24.746094 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcbearingLogo);
export default __webpack_public_path__ + "static/media/BCBEARING-logo.9d78fc41ddbe7a731f64d5ad54cbced4.svg";
export { ForwardRef as ReactComponent };